<template>
    <div v-if="show" class="modal">
        <div class="modal-content max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <span class="close" @click="closeModal">&times;</span>
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <div class="pb-8 pr-6 w-full lg:w-1/2">
                    <p v-html="calendarEvent.modal_title"/>
                </div>
            </div>
            <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button @click="closeModal" :loading="form.processing" class="btn-indigo ml-auto" type="button">
                    Закрити
                </loading-button>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton"
import SelectInput from "@/Shared/SelectInput"
import DatePicker from "@/Shared/DatePicker"
import TextInput from "@/Shared/TextInput"

export default {
    name: "CalendarModal",
    components: { TextInput, DatePicker, SelectInput, LoadingButton },
    props: {
        calendarEvent: Object,
        show: Boolean,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                phone: '',
                lakeId: null,
                latitude: '',
                longitude: '',
                number: '',
                date: '',
                typeId: null,
                pointName: '',
                pointId: null,
            }),
        }
    },
    methods: {
        closeModal() {
            this.$emit('update:show', false);
            this.form.reset();
        },
    }
};
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>
